<template>
    <b-modal
            :visible=visible
            hide-footer
            hide-header
            :size="size"
            :no-close-on-backdrop=noCloseOnBackdrop
            :no-close-on-esc=noClosoOnEsc
            :centered=centered
            modal-class="InterModal">
        <div class="InterModal-Logo">
            <img :src="srcLogo"/>
        </div>
        <div class="InterModal-title"
             v-bind:style="{backgroundColor : `#001ea0`}">
            <div>{{title}}</div>
            <i class="fi" :class="titleIcon" v-if="titleIcon"></i>
        </div>

        <div class="InterModal-body" v-bind:class="{ 'withTopPadding': withTopPadding }">
            <slot></slot>
        </div>

        <div class="InterModal-footer" v-if="showFooter">
            <inter-button v-if="showPrimary"
                          @onClick="$emit('onPrimaryClick')"
                          :label="buttonPrimary.label"
                          :confirm="buttonPrimary.confirm"
            >
            </inter-button>
            <inter-button v-if="showSecondary"
                          class="ml-3"
                          @onClick="$emit('onSecondaryClick')"
                          style-btn="secondary-button"
                          :label="buttonSecondary.label"
                          :confirm="buttonSecondary.confirm"
            >
            </inter-button>
        </div>
    </b-modal>
</template>

<script>
    import _ from "lodash";
    import InterButton from "../form/inter-button/InterButton";
    import {mapGetters} from 'vuex'

    export default {
        name: "InterModal",
        components: {InterButton},
        data() {
            return {
                srcLogo: require('@/assets/media/logo.svg'),
            }
        },
        props: {
            title: {
                type: String,
                require: true
            },
            size: {
                type: String,
                default: 'lg'
            },
            visible: {
                type: Boolean,
                default: false
            },
            noCloseOnBackdrop: {
                type: Boolean,
                default: true
            },
            noClosoOnEsc: {
                type: Boolean,
                default: true
            },
            centered: {
                type: Boolean,
                default: true
            },
            titleIcon: {
                type: [Boolean, String],
                default: false
            },
            buttonPrimary: {
                type: Object,
                default: () => ({})
            },
            buttonSecondary: {
                type: Object,
                default: () => ({})
            },
            withTopPadding: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters([
                'currentUser',
            ]),

            showFooter: function () {
                return !_.isEmpty(this.buttonPrimary) || !_.isEmpty(this.buttonSecondary);

            },
            showPrimary: function () {
                return !_.isEmpty(this.buttonPrimary);

            },
            showSecondary: function () {
                return !_.isEmpty(this.buttonSecondary);

            },
            color: function() {
                return (this.currentUser && this.currentUser.color) ? this.currentUser.color : '#1A639A';
            }
        }
    }
</script>

<style lang="scss">


</style>
